export default "__VITE_PUBLIC_ASSET__04973608__"